import numbro from 'numbro';

const numbroParameter = {
    spaceSeparated: true,
    mantissa: 2,
    optionalMantissa: true,
    thousandSeparated: true,
};
/**
 * Formats the given number as a 2 digits currency string as the following : 14 000,45€
 *
 * @param {number} value - The number to be formatted as currency
 * @return {string} The formatted currency string
 */

export const formatAmountsNumber = (value: number): string =>
    numbro(value).formatCurrency(numbroParameter);
